import styled from 'styled-components';

export const ScPriceListDescription = styled.p``;
